import Cookies from 'cookies-js';

// Capture how a user was referred to the site
export default function referrer() {
  /*
   ** Only run on client-side and only in production mode
   */
  if (process.env.NODE_ENV !== 'production' || process.server) return;

  // Only set cookie if it doesn't exist
  // and if there is a search query or a referrer
  if (
    !Cookies.get('user_referrer') &&
    (window.location.search || document.referrer)
  ) {
    Cookies.set(
      'user_referrer',
      JSON.stringify({
        url: window.location.href,
        referrer: document.referrer,
      }),
      { domain: '.campsite.bio', expires: 7 * 24 * 60 * 60 },
    );
  }
}
